<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
        ref="grid"
        v-model="selected"
        value-key="IdBankAccount"
        :id-vista="idVista"
        :spanish="spanish"
        :data='data'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @actionclick='openPath'
        @datastatechange='dataStateChange'>
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' 
            :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="!isRoleUserConsultaProvider" mode="primary" :text="$t('agenda.add_bank_account')" icon="plus" @click="goNewAccount" 
            :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="!isRoleUserConsultaProvider"
      >
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more" v-if="!isRoleUserConsultaProvider" >
          <span v-for="action in getAccionesPosibles" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)">
              <base-icon :name="action.icon" class="mr-2" />
              {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <Dialog :title="$t('agenda.delete_bank_account')" :visible.sync="showModal" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDelete
        }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')"
              @click="() => { deleteHandler(); showModal = false }" />
          </div>
        </template>
      </Dialog>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" :vuexnamespace="'bankaccounts'" />
      <create-search-dialog
        :numberSearches="numberSearches"
        :idVista="idVista"
        :dialogOpen="saveSearchDialog"
        :tags="tags"
        @toggleDialog="toggleDialogSearches"
        @applyDialog="applySearchHandler" />
      <filter-panel-searches
        ref="filterPanelSearches"
        :idVista="idVista"
        :vuexnamespace="vuexnamespace"
        :panelOpen="searchesPanel"
        @togglePanel="toggleSearchesDialog"
        @applyFilters="applyFiltersHandler"
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import { i18n } from '@/i18n'
import { Dialog } from 'element-ui'

import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/BankAccountFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'

import { getSede } from '@/services/configurations/getSede'
import { getSedesCuentasBancariasPag } from '@/services/configurations/getSedesCuentasBancariasPag'
import { getSedesCuentasBancariasExcel } from '@/services/configurations/getSedesCuentasBancariasExcel'
import { deleteCuentaBancaria } from '@/services/configurations/deleteCuentaBancaria'
import { setBankAccounDefault } from '@/services/configurations/setBankAccountDefault'


export default {
  name: 'bank-accounts',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    Dialog,
  },
  data: function () {
    return {
      idVista: 82,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      showModal: false,
      spanish: true,
      header: {
        title: i18n.t('agenda.cuentas_bancarias').toUpperCase(),
        icon: 'config',
        breadcrumb: null,
        url: 'masters/society/locations/details'
      },
      listaAcciones: [
        { IdAccion: 0, Descripcion: i18n.t('app.remove'), icon: 'trash' },
        { IdAccion: 1, Descripcion: i18n.t('agenda.set_default_bank_account'), icon: 'pagar' },
      ],
      vuexnamespace: 'bankaccounts',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      processMessageDelete: i18n.t('app.delete_selected_confirmation_f', { entity: i18n.t('agenda.cuentas_bancarias').toLowerCase() }),
    }
  },
  computed: {
    getAccionesPosibles: function () {
      let listaAccionesFinal = this.listaAcciones.slice()
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 1) {
        listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 1)
      }
      return listaAccionesFinal
    },
    isRoleProvider: function () {
      return this.role === 9
    }, 
    isRoleUserConsultaProvider: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
    id () {
      return parseInt(this.$route.params.id)
    },
    idSede () {
      return parseInt(this.$route.params.idSede)
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? i18n.t('app.only_selected') : i18n.t('app.see_all')
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    columns () {
      return [
        { field: 'selected', width: '50px', headerSelectionValue: this.areAllSelected, reorderable: false, groupable: false },
        ...this.kendo.columns
      ]
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    pgeTypes: function () {
      return this.$store.getters['config/TIPOS_PGE']
    },
    pgeTypesRecepcion: function () {
      return this.$store.getters['config/TIPOS_PGE_RECEPCION']
    }
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
  },
  mounted: async function () {
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)

    const breadcrumbs = []

    breadcrumbs.push({
      path: 'masters',
      name: i18n.t('masters.header')
    })
    breadcrumbs.push({ path: 'masters/society', name: i18n.t('agenda.sociedad') })
    breadcrumbs.push({ path: 'masters/society/locations', name: i18n.t('sedes.header') })
    
    const cabeceraStored = this.$store.getters['app/headerBreadCrumb']
    if (this.$store.getters['app/fromRouteName'] !== null && cabeceraStored) {
      breadcrumbs.push({ path: '', name: cabeceraStored.LocationName })
    } else {
      const sede = await this.downloadData()
      const cabecera = sede.LocationName || ' '
      breadcrumbs.push({ path: '', name: cabecera })
      this.$store.commit('app/setheaderBreadCrumb', { LocationName: cabecera, SendType: sede.SendType })
    }

    this.header.breadcrumb = breadcrumbs

    this.data = await this.applyFilters()
  },
  methods: {

    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 0) { // Borrar
        this.deleteToggle()
      } else if (this.selectedAction.IdAccion === 1) { // Editar
        this.setDefaultHandler()
      } else {
        console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
      }
    },
    deleteToggle: async function () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload ={
          IdSociedad: this.id,
          IdSede: this.idSede,
          IdBankAccounts: this.selected || []
        }
        const response = await deleteCuentaBancaria(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.unselect()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    setDefaultHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload ={
          IdSociedad: this.id,
          IdSede: this.idSede,
          IdBankAccount: this.selected[0] || ''
        }
        const response = await setBankAccounDefault(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.unselect()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    openPath: function (event) {
      this.$router.push({ 
        name: 'masters/society/locations/bankaccounts/details', 
        params: { id: this.id, idSede: event.dataItem.IdSede, idCuenta: event.dataItem.IdBankAccount } 
      })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleDialogs: function () {
      this.linkCompany = !this.linkCompany
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        IdSociedad: this.id,
        IdSede: this.$route.params.idSede,
        IBANAccountNumber: data.IBANAccountNumber ? data.IBANAccountNumber.value : null,
        BIC: data.BIC ? data.BIC.value : null,
        DomiciliationDateFrom: data.domiciliationFrom ? data.domiciliationFrom.value : null,
        DomiciliationDateTo: data.domiciliationTo ? data.domiciliationTo.value : null,
        BankAccountAlias: data.BankAccountAlias ? data.BankAccountAlias.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.IdBankAccount)
        payload.listaIDs = selectedIDs
      }
      try {
        const response = await getSedesCuentasBancariasExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = `${i18n.t('agenda.cuentas_bancarias').replaceAll(' ', '').toLowerCase()}.xlsx`
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idSociedad: this.id,
        idSede: this.$route.params.idSede,
        IBANNumeroCuenta: data.IBANAccountNumber ? data.IBANAccountNumber.value : null,
        BIC: data.BIC ? data.BIC.value : null,
        DomiciliationDateFrom: data.domiciliationFrom ? data.domiciliationFrom.value : null,
        DomiciliationDateTo: data.domiciliationTo ? data.domiciliationTo.value : null,
        MandateID: data.MandateID ? data.MandateID.value : null,
        DefaultBankAccount: data.DefaultBankAccount ? data.DefaultBankAccount.value : null,
        BankAccountAlias: data.BankAccountAlias ? data.BankAccountAlias.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const data = await this.getItemsData(objOrder, params)
        return data.map(item => {
          item.FormaEnvio= this.pgeTypes.find(x => x.id=== item.FormaEnvio)?.name ?? 
          (this.pgeTypesRecepcion.find(x => x.id=== item.FormaEnvio)?.name ?? item.FormaEnvio)
          return item
        })
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback()
      }
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = this.data = res.respuesta?.map((item) => {
        item.Address = item.Address || {}
        item.Address.Address = item.Address.Address || ''
        item.Address.PostCode = item.Address.PostCode || ''
        item.Address.Town = item.Address.Town || ''
        item.Address.Province = item.Address.Province || ''
        item.Address.CountryCode = item.Address.CountryCode || ''
        return item
      })
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getSedesCuentasBancariasPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    downloadData: async function () {
      let contact = null
      try {
        this.$store.commit('setIsLoading', true)

        const params = {
          IdSociedad: this.id,
          IdSede: this.idSede
        }
        contact = await getSede(params)
        if (contact.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', contact))
        } else {
          contact = contact.respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return contact
    },
    unselect: function () {
      this.selected = []
    },
    goNewAccount: function () {
      this.$router.push({ 
        name: 'masters/society/locations/bankaccounts/details', 
        params: { id: this.id, idSede: this.$route.params.idSede, idCuenta: -1 } 
      })
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
